import React from "react";
import Header from "../components/header.js";
import Footer from "../components/footer.js";

import {
  Container,
  AboutContainer,
  ImagesContainer,
  MiddleContainer,
  ContactContainer,
  GridImages,
  MobileImage,
  CircleOne,
  CircleTwo,
  CircleFour,
  CircleFive,
  AboutOne,
  AboutTwo,
  MobileOne,
  MobileTwo,
} from "../styles/about/about.js";

import One from "../assets/1.png";
import Two from "../assets/2.png";
import Three from "../assets/3.png";
import Four from "../assets/4.png";
import Five from "../assets/5.png";

import About1 from "../assets/about1.png";
import About2 from "../assets/about2.png";

import Mobile from "../assets/mobile.png";
import Mobile1 from "../assets/mobile1.png";
import Mobile2 from "../assets/mobile2.png";

import CircleFirst from "../assets/circle1.png";
import CircleSecond from "../assets/circle2.png";
import CirlceFifth from "../assets/circle5.png";
import FadeIn from "../components/HOC/fade-in-inview.js";

const About = () => {
  return (
    <>
      <FadeIn>
        <Header />
      </FadeIn>
      <Container>
        <FadeIn>
          <AboutContainer id="about">
            <h2>About us</h2>
            <hr />
            <h1>The best care is of no use if you can’t find it</h1>
            <h3>We help you find and access care</h3>
            <ImagesContainer>
              <img className="leftImage" src={One} alt="" />
              <GridImages>
                <img src={Two} alt="" />
                <img src={Three} alt="" />
                <img src={Four} alt="" />
                <img src={Five} alt="" />
              </GridImages>
              <MobileImage src={Mobile} alt="" />
            </ImagesContainer>
            <h2>Our Story</h2>
            <p>
              Healthcare is complicated. Navigating healthcare when we need it
              is even worse. That is why Aeydar set out to help people find and
              access care when they need it. Aeydar helps people navigate the
              healthcare space online and offline by letting them discover the
              best care options using search and filter. It also provides a
              simple to use navigation map that helps users get to the care
              facility.
            </p>
            <CircleOne src={CircleFirst} alt="" />
            <CircleTwo src={CircleSecond} alt="" />
            <CircleFour src={CircleFirst} alt="" />
            <CircleFive src={CirlceFifth} alt="" />
          </AboutContainer>
        </FadeIn>
        <FadeIn>
          <MiddleContainer>
            <h1>Powered by tech, driven by people</h1>
            <p>So you can find the care you need</p>

            <AboutOne src={About1} alt="" />
            <AboutTwo src={About2} alt="" />
            <MobileOne src={Mobile1} alt="" />
            <MobileTwo src={Mobile2} alt="" />
          </MiddleContainer>
        </FadeIn>
        <FadeIn>
          <ContactContainer id="contact">
            <h2>Contact us</h2>
            <form>
              <input type="text" placeholder="Name" required />
              <br />
              <input type="email" placeholder="Email" required />
              <br />
              <textarea required rows="10" placeholder="Message"></textarea>
              <br />
              <input type="submit" className="submit" value="Send" />
            </form>
          </ContactContainer>
        </FadeIn>
      </Container>
      <Footer />
    </>
  );
};

export default About;
